module.exports = __webpack_public_path__ + "img/CAChicken.46621a29.gif";